import styled from "styled-components";
import Stack from "./Stack";

const UnorderedList = styled(Stack).attrs({ as: "ul" })`
  list-style: none;
`;

export default UnorderedList;
